import React, { Component } from 'react'
import { observable, action } from 'mobx'
import { observer } from 'mobx-react'
import Ring from 'components/Common/Ring'
import styles from './my-record.css'
import { getUserInfo } from 'common/user'
import { getUserStatistics } from 'common/api'
import config from 'config'

@observer
export default class MyRecord extends Component {
  @observable show = false
  @observable avatar = ''
  @observable nickname = ''
  @observable totalFinishedNum = 0
  @observable finishedNum = 0
  @observable targetNum = 100

  componentDidMount () {
    const userInfo = getUserInfo()

    if (!userInfo) { return }

    getUserStatistics(userInfo.token)
      .then(action('getUserStatistics end', json => {
        if (json.code !== 0) {
          this.show = false
        } else {
          this.show = true
          this.avatar = config.cdnCommon + json.data.avatar
          this.nickname = json.data.nickname
          this.totalFinishedNum = json.data.totalFinishedNum
          this.finishedNum = json.data.finishedNum
          this.targetNum = json.data.targetNum
        }
      }))
  }

  renderUserInfo () {
    return (
      <div className={ styles.userInfo }>
        <img className={ styles.userAvatar } src={ this.avatar } alt="用户头像" />
        <div className={ styles.userText }>
          <div className={ styles.userName }>{ this.nickname }</div>
          <div className={ styles.userCompleted }>已完成 { this.totalFinishedNum } 道题</div>
        </div>
      </div>
    )
  }

  renderPracticeInfo () {
    return (
      <div className={ styles.practiceInfo }>
        <Ring radius={ 80 } ringWidth={ 20 } percent={ Math.floor(this.finishedNum / this.targetNum) } color="#39f" background="#f5f5f5" cap="round">
          <div className={ styles.practiceText }>
            <div className={ styles.practiceToday }>今日练习</div>
            <div className={ styles.practiceScore }>{ this.finishedNum }</div>
          </div>
        </Ring>
      </div>
    )
  }

  renderTarget () {
    return (
      <div className={ styles.target }>
        <div className={ styles.targetButton }>设置每日做题目标</div>
        <div className={ styles.targetTip }>给自己设立明确的目标, 每天学习更有动力!</div>
      </div>
    )
  }

  render () {
    if (!this.show) { return null }

    return (
      <div className={ styles.root }>
        <div className={ styles.title }>我的练习记录</div>
        <div className={ styles.hr }></div>
        <div className={ styles.content }>
          { this.renderUserInfo() }
          { this.renderPracticeInfo() }
          { this.renderTarget() }
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Home/Aside/MyRecord.js
 **/